import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { catchError, EMPTY, of, Subscription, switchMap } from "rxjs";
import { HelpersService } from "../../../../core/services/helpers.service";
import { ModalNotifyService } from "../../../../core/services/modal-notify.service";
import { OperationsService } from '../../../../core/services/operations.service';
import { DocumentoAllegato } from "../../../models/documento-allegato";
import { FileFolders } from "../../fascicolo/documentazione-allegata-view/documentazione-allegata.component";
import { ConfigurationService } from 'src/app/common/configuration/services/configuration.service';
import { ConfigurationFeature } from 'src/app/common/configuration/models/configuration';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { SelezioneFascicoliSecondariComponent } from 'src/app/common/protocol/components/fascicolo/dialog/selezione-fascicoli-secondari/selezione-fascicoli-secondari.component';


// -----------------------------
// Stati e operazioni del documento
// -----------------------------
export type DocState = 
  | 'FORMATO'
  | 'FIRMATO'
  | 'PROTOCOLLATO'
  | 'ANNULLATO';

export type DocOperation =
  | 'download'
  | 'uploadVersion'
  | 'move'
  | 'viewDetail'
  | 'editMetadata'
  | 'viewHistory'
  | 'delete'
  | 'sign'
  | 'protocol'
  | 'stamp'
  | 'editPrincipale'
  | 'cancelProtocol';

export const STATE_ALLOWED_OPERATIONS: Record<DocState, DocOperation[]> = {
  FORMATO: ['download','uploadVersion','move','viewDetail','editMetadata','viewHistory','delete','sign','protocol'],
  FIRMATO: ['download','move','viewDetail','editMetadata','viewHistory','protocol','delete'],
  PROTOCOLLATO: ['download','move','viewDetail','editMetadata','viewHistory','stamp','cancelProtocol','editPrincipale','delete'],
  ANNULLATO: ['download','move','viewDetail','editMetadata','viewHistory'],
};
@Component({
  selector: 'app-option-file-component',
  templateUrl: './option-file-component.component.html',
  styleUrls: ['./option-file-component.component.css']
})
export class OptionFileComponentComponent implements OnInit, OnDestroy {
  @Input() item: FileFolders;
  @Input() isTable = false;
  @Input() fascicolo: FascicoloFull = null;
  @Output() onReturn = new EventEmitter();
  @Output() openModal = new EventEmitter();
  @Output() openModalSpostaDoc = new EventEmitter();
  @Output() openHistoryModal = new EventEmitter();
  @Output() onOpenUpdateMetadatiModal = new EventEmitter();
  @Output() sezione = new EventEmitter();
  @Output() onOpenDetailModal = new EventEmitter();
  @Output() removDoc = new EventEmitter();
  @Output() removDocFascicolo = new EventEmitter<{ documento: DocumentoAllegato, nuovoFascicolo: any }>();
  @Output() firmaDoc = new EventEmitter();
  @Output() timbraDoc = new EventEmitter();
  @Output() annullaProtocolDoc = new EventEmitter();
  @Output() onOpenProtocolDocModal = new EventEmitter();
  deleteFileSubscription: Subscription;
  isFirmaEnable: boolean;
  isProtocolEnabled: boolean;

  constructor(private helpersService: HelpersService, private modalNotifyService: ModalNotifyService, 
    private ops: OperationsService , private configService : ConfigurationService,
    private dialog: DialogService,) { }

  ngOnInit() {
    this.isFirmaEnable = this.configService.isFeatureEnabled(ConfigurationFeature.SIGN_DOCUMENT);
    this.isProtocolEnabled = this.configService.isFeatureEnabled(ConfigurationFeature.PROTOCOL);
  }

  downloadFile(idDocumento, documento: DocumentoAllegato) {
    if (documento.refDocumentale) {
      this.helpersService.downloadDocument(documento.id).subscribe();
    }
  }

  salvaFile(content, fileName) {
    var FileSaver = require('file-saver')
    const byteCharacters = atob(content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/octet-stream"
    });
    const name = fileName;
    try {
      FileSaver.saveAs(blob, name);
    } catch (err) {
      window.navigator.msSaveBlob(blob, fileName);
    }
  }

  openModalCallback(documento: DocumentoAllegato) {
    this.openModal.emit(documento);
  }

  openMoveDocModal(documento: DocumentoAllegato) {
    this.openModalSpostaDoc.emit(documento);
  }

  openHistoryModalCallback(documento: DocumentoAllegato) {
    this.openHistoryModal.emit(documento);
  }

  openUpdateMetadatiModal(documento: DocumentoAllegato, item) {
    this.sezione.emit(item.section.esn)
    this.onOpenUpdateMetadatiModal.emit(documento);
  }

  openDetailModal(documento: DocumentoAllegato) {
    this.onOpenDetailModal.emit(documento);
  }
  openFirmaModal(documento: DocumentoAllegato){
    this.firmaDoc.emit(documento)
  }

  openTimbraModal(documento: DocumentoAllegato){
    this.timbraDoc.emit(documento)
  }

  openAnnullaProtocolModal(documento: DocumentoAllegato){
    this.annullaProtocolDoc.emit(documento)
  }
  
  deleteDocNotify(documento: DocumentoAllegato, item) {
    this.openDialogEliminaDocumento(documento,item);
  }

  openDialogEliminaDocumento(documento: DocumentoAllegato, item) {
    if (!!documento.numeroProtocollo && !!documento.flagAttoPrincipale) {
      this.helpersService
        .checkDeleteDocumento(item.section.id, documento.id)
        .pipe(
          switchMap((isDeletable: boolean) => isDeletable ? this.helpersService.searchByProtocollo(documento.numeroProtocollo, false) : EMPTY)
        )
        .subscribe({
          next: (result: any) => {
            console.log(result)
            if (result && Array.isArray(result) && result.length > 0) {
              const messaggio = `Stai per eliminare l’associazione del protocollo ${documento.numeroProtocollo} al fascicolo principale ${this.fascicolo.posizione}.`;
              this.modaleSelezioneFascicoliSecondari(documento, result ?? [], messaggio);
            } else {
              this.deleteDocument(documento);
            }
          },
          error: (err) => {
            console.log('checkDeleteDocumento errore:', err);
          }
        });
    } else {
      this.deleteDocument(documento);
    }
  }

  modaleSelezioneFascicoliSecondari(documento: DocumentoAllegato, fascicoli: any[], messaggio: string) {
    const ref = this.dialog.open(SelezioneFascicoliSecondariComponent, {
      data: {
        style: { width: "50%" },
        title: "Imposta nuovo fascicolo principale",
        message: messaggio,
        fascicoliDisponibili: fascicoli,
        fascicoloCorrente: this.fascicolo
      }
    });

    ref.afterClosed.subscribe(event => {
      if (!event) return;

      if (event?.modalEvent === true) {
        const nuovoFascicolo = event.selectedFascicolo ?? null;

        if (nuovoFascicolo) {
          // utente ha scelto un nuovo fascicolo => emetto removDocFascicolo (riassegna + elimina)
          this.removDocFascicolo.emit({ documento, nuovoFascicolo });
        } else {
          // nessun fascicolo scelto ma conferma premuta => elimina direttamente
          this.removDoc.emit(documento);
        }
      }
    });
  }

  private deleteDocument(documento: DocumentoAllegato) {
    const ref = this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: "Confermare la cancellazione del file?",
        },
        style: { width: "50%" },
        title: "Conferma",
      }
    });
    this.deleteFileSubscription = ref.afterClosed.subscribe(event => {
      if (event?.modalEvent === true) {
        this.removDoc.emit(documento);
      }
      this.deleteFileSubscription.unsubscribe();
    });
  }

  openProtocolModal(documento: DocumentoAllegato) {
    this.onOpenProtocolDocModal.emit(documento);
  }

  setAsPrincipale(documento: DocumentoAllegato, idSezione: string) {
    // Recupero i fascicoli associati al documento tramite numeroProtocollo
    this.helpersService.searchByProtocollo(documento.numeroProtocollo, true)
      .subscribe(result => {
        const fascicoloPrincipaleCorrente = result[0];
        const messaggio = `Sei sicuro di voler modificare l’associazione dell’atto al fascicolo principale?
        Attualmente il fascicolo principale è: ${fascicoloPrincipaleCorrente.posizioneFascicolo}.
        Confermi la modifica?`;

        const ref = this.dialog.open(ConfirmModalComponent, {
          data: {
            modalConfirm: { text: messaggio },
            style: { width: '50%' },
            title: 'Modifica fascicolo principale'
          }
        });

        ref.afterClosed.subscribe(event => {
          if (event?.modalEvent === true) {
            // Chiamata al servizio per modificare il fascicolo principale
            this.modificaFascicoloPrincipale(documento, idSezione, fascicoloPrincipaleCorrente.idFascicolo);
          }
        });
      });
  }

  modificaFascicoloPrincipale(documento: DocumentoAllegato, idSezione: string, idFascicoloPrincipale: string): void {
    const payload = {
      idDocumento: documento.id,
      idFascicoloPrincipale: idFascicoloPrincipale,
      idSezione:idSezione
    };
    this.helpersService.impostaPrincipale(payload).subscribe({
      next: (response) => {
        this.onReturn.emit(true);
      },
      error: (err) => {
        console.log('Errore nel modificare fascicolo principale', err);
      }
    });
  }

  ngOnDestroy() {
    if (this.deleteFileSubscription) {
      this.deleteFileSubscription.unsubscribe();
    }
  }

  isFilePresent(documento): boolean {
     return documento?.missingFile !== true;
  }

  isOperationEnabled(operation: DocOperation, item: any): boolean {
    if (!item.documento) return false;

    // Stato del documento
    const stato: DocState = (item.documento.statoDocumento?.toUpperCase() || 'FORMATO') as DocState;
    const statoConservazione: string = item.documento.statoConservazione?.toLowerCase() || '';

    // Controllo se l'operazione è tra quelle consentite per lo stato
    const allowedOps = STATE_ALLOWED_OPERATIONS[stato] || [];
    if (!allowedOps.includes(operation)) {
      return false;
    }
    // Verifico che la sezione sia scrivibile per alcune operazioni
    const writeOps: DocOperation[] = ['uploadVersion','move','editMetadata','delete','sign','protocol','stamp','cancelProtocol','editPrincipale'];
    if (writeOps.includes(operation) && !item.section?.writable) {
      return false;
    }

    // Verifico che ci sia un file per alcune operazioni
    const fileRequiredOps: DocOperation[] = ['download','uploadVersion','move','viewDetail','viewHistory','sign','protocol','stamp','cancelProtocol','delete','editPrincipale'];
      if (fileRequiredOps.includes(operation) && !this.isFilePresent(item.documento)) {
        return false;
      }

       // Operazioni speciali basate su statoConservazione
      if (statoConservazione === 'inviato') {
        // Se lo stato è inviato, non posso eliminare, firmare, protocollare o fare upload di nuova versione
        if (['delete', 'uploadVersion','sign', 'protocol'].includes(operation)) {
          return false;
        }
      }

      if (statoConservazione === 'conservazione_manuale') {
        // Se lo stato è conservazione_manuale, non posso fare upload
        if (['uploadVersion'].includes(operation)) {
          return false;
        }
      }

      if (operation === 'protocol') {
        if (!this.isProtocolEnabled) return false;
        if (item.documento.dataProtocollazione) return false;
      }

      if (operation === 'sign' && !this.isFirmaEnable) {
        return false;
      }

      if (operation === 'stamp') {
        if (!item.documento.numeroProtocollo) return false;
        if (item.documento.flagAllegatoPrincipale !== true) return false;
      }

      if (operation === 'editPrincipale') {
        // deve essere visibile SOLO se:
        // - non è già atto principale
        // - è un allegato principale
        if (item?.documento?.flagAttoPrincipale === true) {
          return false; // già principale → non mostra l’opzione
        }

        if (item?.documento?.flagAllegatoPrincipale !== true) {
          return false; // non è un allegato principale → non mostra l’opzione
        }
        if (!item.documento.numeroProtocollo) {
          return false;
        }
      }
      if (operation === 'cancelProtocol') {
        // deve essere documento protocollato
        if (stato !== 'PROTOCOLLATO') return false;
        // deve essere primario
        if (!item.documento.flagAllegatoPrincipale) return false;
      }
      // protocollato + non importato
      if (operation === 'delete' &&
        stato === 'PROTOCOLLATO' &&
        ['inviato', 'conservato'].includes(statoConservazione)
      ) {
        return false;
      }
      //posso protocollare solo documento firmato con firma non valida (SONO IN STATO FORMATO) e tipoUfficioProduttore esterno
      if (operation === 'protocol' && stato === 'FORMATO') {
        // firmaNonValida = true solo se c'è almeno una firma e non è valida
        const firmaNonValida = item.documento.metadatoFirmaDocumenti?.some(
            f => f.firmaPresente === true && f.esitoVerifica?.id === 'NON_VALIDA'
        ) ?? false;
        // produttore interno
        const produttoreInterno = item.documento.metadatoDocumento?.tipoUfficioProduttore?.id === 'INTERNO';

        // disabilita solo se entrambe le condizioni sono vere
        if (firmaNonValida && produttoreInterno) {
            return false; // disabilita il tasto
        }
      }
      return true;
    } 

}
